import { Step } from '../flow';
import { useSurvey } from '../SurveyContext';

export function ChoiceStep({ step }: { step: Step }) {
  const surveyFlow = useSurvey();
  const field = step.field!;
  const selected = String(surveyFlow.answers[field] ?? '');
  if (step.row) {
    return (
      <div className="intake-opts intake-row">
        {step.options!.map((o) => (
          <button type="button"
            key={o.value}
            className="intake-opt intake-rowopt"
            aria-pressed={selected === o.value}
            onClick={() => surveyFlow.selectChoice(field, o.value)}
          >
            {o.emoji ? <span className="intake-oemoji">{o.emoji}</span> : null}
            <span className="intake-otext">
              <span className="intake-olabel">{o.label}</span>
              {o.note ? <span className="intake-note">{o.note}</span> : null}
            </span>
          </button>
        ))}
      </div>
    );
  }
  return (
    <div className="intake-opts">
      {step.options!.map((o, i) => (
        <button type="button"
          key={o.value}
          className="intake-opt"
          aria-pressed={selected === o.value}
          onClick={() => surveyFlow.selectChoice(field, o.value)}
        >
          <span className="intake-k">{i + 1}</span>
          <span>
            {o.label}
            {o.note ? <span className="intake-note"> — {o.note}</span> : null}
          </span>
        </button>
      ))}
    </div>
  );
}
